import urlUtil from 'root/common/util/url';
import { appDestroyPage } from 'root/common/nativeApi';
import env from 'root/common/util/env.js';
import storage from 'root/common/util/storage';
export default {
    created() {
        const search = urlUtil.getQuery(decodeURI(location.href));
        if (search.alipayStudentComplete || search.alipayStudentCancel) {
            this.destroyLastPage();
        }
    },
    methods: {
        destroyLastPage() {
            if (env.isApp) {
                const lastSamePage = storage.get(storage.keys.lastSamePageByAliVerify); //上一个相同页面
                const registerUrl = storage.get(storage.keys.registerUrlByAliVerify); //注册页面
                setTimeout(() => {
                    if (lastSamePage || registerUrl) {
                        appDestroyPage([lastSamePage, registerUrl])
                            .then(res => {
                                console.log(res, '结果');
                                storage.remove(storage.keys.lastSamePageByAliVerify);
                                storage.remove(storage.keys.registerUrlByAliVerify);
                            })
                            .catch(err => {
                                console.log(err, '');
                                window.monitor &&
                                    window.monitor.report({
                                        level: 'info',
                                        url: window.location.href,
                                        msg: `支付宝身份认证业务回退销毁页面失败`,
                                    });
                            });
                    }
                }, 600);
            }
        },
    },
};
